// Client quotes. The first three came from earlier web-design engagements;
// keep, edit, or replace as new automation engagements close.

const testimonials = [
  {
    id: "harry-wilson",
    name: "Harry Wilson",
    role: "Photographer",
    project: "Artsy",
    quote:
      "I had the pleasure of working with Ay on a recent web project, and I was thoroughly impressed with his skills and work ethic. His attention to detail and commitment to delivering high-quality work is admirable. He's a great communicator and always kept me informed about progress.",
  },
  {
    id: "adewale-onakoya",
    name: "Adewale Onakoya",
    role: "Founder",
    project: "Minimum Living Home",
    quote:
      "Working with Ayomikun was a pleasure. He took our design concepts and turned them into a site that exceeded what we'd imagined. Great eye for design and a deep understanding of the work. Always willing to go the extra mile to make sure the project landed.",
  },
  {
    id: "lord-garry",
    name: "Lord Garry",
    role: "Designer",
    project: "Paw Care",
    quote:
      "Ayomikun's attention to detail and expertise are seriously impressive. He's always willing to share insights and recommendations that improve the work. An excellent communicator who keeps me updated every step of the way.",
  },
];

export default testimonials;
